import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {GenericDocEventsContainerModel} from '../../../../../../models/aggregates/generic_doc';

// /core2/tnt/dm/erp/generic-doc/events/login-entity-ep

@Injectable({
  providedIn: 'root'
})
export class GenericDocEventLoginentityEPService extends BaseApiTemplateService<GenericDocEventsContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 
  Core2Config.ERP_PREFIX + 'generic-doc/events';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/events/login-entity-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/events/login-entity-ep';
    this.httpClient = http;
  }
}
